// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as NLOrderTimes from "./NLOrderTimes.bs.js";
import * as CountryContext from "../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as NLOrderStatusInfo from "./NLOrderStatusInfo.bs.js";
import * as CardTitleWithImage from "./CardTitleWithImage.bs.js";
import * as NLOrderDeliveryNote from "./NLOrderDeliveryNote.bs.js";
import * as NLOrderServicesInfo from "./NLOrderServicesInfo.bs.js";
import * as NLOrderTollsBreakup from "./NLOrderTollsBreakup.bs.js";
import * as NLOrderWaypointInfo from "./NLOrderWaypointInfo.bs.js";
import * as NLOrdersLocationInfo from "./NLOrdersLocationInfo.bs.js";
import * as PrimaryCard$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/primary-card/PrimaryCard.bs.js";
import * as NLOrderLoadAssistInfo from "./NLOrderLoadAssistInfo.bs.js";
import * as OrderDashboardAssetsManager from "../../../assets/OrderDashboardAssetsManager.bs.js";

var locator_icon = OrderDashboardAssetsManager.getImage("locator.svg");

function NLOrderTripInfo(Props) {
  var order = Props.order;
  var order_fare = Props.order_fare;
  var load_assist_info = Props.load_assist_info;
  var match = CountryContext.useContext(undefined).country;
  var tmp;
  switch (match.TAG | 0) {
    case /* BD */2 :
    case /* MY */4 :
        tmp = null;
        break;
    default:
      tmp = React.createElement(NLOrderDeliveryNote.make, {
            order: order
          });
  }
  return React.createElement(PrimaryCard$Catalyst.make, {
              title: {
                TAG: /* Custom */1,
                _0: (function (param) {
                    return React.createElement(CardTitleWithImage.make, {
                                title: "Trip Information",
                                icon_src: locator_icon
                              });
                  })
              },
              action: undefined,
              className: "primary-info-card c-trip-info-card",
              children: null
            }, React.createElement(NLOrderServicesInfo.make, {
                  order: order
                }), React.createElement(NLOrdersLocationInfo.make, {
                  order: order
                }), React.createElement(NLOrderWaypointInfo.make, {
                  order: order
                }), React.createElement(NLOrderTimes.make, {
                  order: order,
                  order_fare: order_fare
                }), React.createElement(NLOrderStatusInfo.make, {
                  order: order
                }), React.createElement(NLOrderTollsBreakup.make, {
                  order_fare: order_fare
                }), tmp, load_assist_info !== undefined ? React.createElement(NLOrderLoadAssistInfo.make, {
                    load_assist_info: load_assist_info
                  }) : null);
}

var make = NLOrderTripInfo;

export {
  locator_icon ,
  make ,
  
}
/* locator_icon Not a pure module */
